module.exports = __webpack_public_path__ + "img/pt-single-1.6122e335.jpg";